export default "__VITE_ASSET__1816363e__"